<ion-header>
  <ion-toolbar mode="ios">
    <ion-buttons slot="start">
      <ion-button (click)="modalCtrl.dismiss()">Cancel</ion-button>
    </ion-buttons>
    <ion-title>Error Tester</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-card>
    <ion-card-content>Select a type of error to trigger:</ion-card-content>
  </ion-card>
  <ion-list>
    <ion-item lines="none">
      <ion-button expand="block" color="primary" (click)="sentry.test('manual')">
        <ion-icon name="bug-outline" slot="start"></ion-icon>
        Manual Error
      </ion-button>
    </ion-item>
    <ion-item lines="none">
      <ion-button expand="block" color="danger" (click)="sentry.test('uncaught')">
        <ion-icon name="warning-outline" slot="start"></ion-icon>
        Uncaught Error
      </ion-button>
    </ion-item>
    <ion-item lines="none">
      <ion-button expand="block" color="tertiary" (click)="sentry.test('promise')">
        <ion-icon name="refresh-circle-outline" slot="start"></ion-icon>
        Promise Rejection
      </ion-button>
    </ion-item>
    <ion-item lines="none">
      <ion-button expand="block" color="danger" (click)="sentry.test('http')">
        <ion-icon name="cloud-offline-outline" slot="start"></ion-icon>
        HTTP Error
      </ion-button>
    </ion-item>
    <ion-item lines="none">
      <ion-button expand="block" color="primary" (click)="sentry.test('custom')">
        <ion-icon name="construct-outline" slot="start"></ion-icon>
        Custom Error
      </ion-button>
    </ion-item>
    <ion-item lines="none">
      <ion-button expand="block" color="medium" (click)="sentry.test('native')">
        <ion-icon name="phone-portrait-outline" slot="start"></ion-icon>
        Native Crash (iOS/Android only)
      </ion-button>
    </ion-item>
    <ion-item lines="none">
      <ion-button expand="block" color="secondary" (click)="sentry.test('console')">
        <ion-icon name="terminal-outline" slot="start"></ion-icon>
        Console Error
      </ion-button>
    </ion-item>
    <ion-item lines="none">
      <ion-button expand="block" color="danger" (click)="sentry.test('api-runtime')">
        <ion-icon name="alert-circle-outline" slot="start"></ion-icon>
        API Runtime Error
      </ion-button>
    </ion-item>
    <ion-item lines="none">
      <ion-button expand="block" color="tertiary" (click)="sentry.test('api-validation')">
        <ion-icon name="checkmark-done-outline" slot="start"></ion-icon>
        API Validation Error
      </ion-button>
    </ion-item>
    <ion-item lines="none">
      <ion-button expand="block" color="danger" (click)="sentry.test('api-query')">
        <ion-icon name="server-outline" slot="start"></ion-icon>
        API DB Query Error
      </ion-button>
    </ion-item>
    <ion-item lines="none">
      <ion-button expand="block" color="danger" (click)="sentry.test('api-queue')">
        <ion-icon name="time-outline" slot="start"></ion-icon>
        API Queue Failure
      </ion-button>
    </ion-item>
    <ion-item lines="none">
      <ion-button expand="block" color="danger" (click)="sentry.test('api-s3')">
        <ion-icon name="cloud-offline-outline" slot="start"></ion-icon>
        API S3 Error
      </ion-button>
    </ion-item>
    <ion-item lines="none">
      <ion-button expand="block" color="primary" (click)="sentry.test('api-custom')">
        <ion-icon name="build-outline" slot="start"></ion-icon>
        API Custom Error
      </ion-button>
    </ion-item>
  </ion-list>
</ion-content>
